<template>
    <span id="counsellor-delete">
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-action btn-danger btn-sm mb-2" data-toggle="modal"
            :data-target="getDataTarget()"><i class="fas fa-trash"></i></button>

        <!-- Modal -->
        <div class="modal fade text-left" :id="getModalId()" tabindex="-1" aria-labelledby="counsellorDeleteLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="counsellorDeleteLabel">Delete Counsellor</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        Are you sure you want to <b>delete</b> the counsellor <b>{{ counsellor.givenName }}
                            {{ counsellor.surname }}</b>? This action cannot be undone!
                        Please click confirm to proceed.
                    </div>
                    <div class="modal-footer">
                        <button v-if="loading" type="button" class="btn btn-danger" disabled>Deleting <i
                                class="fas fa-spinner fa-spin"></i></button>
                        <button v-else type="button" class="btn btn-danger" @click="deleteCounsellor()">Confirm</button>
                        <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
import $ from 'jquery';

export default {
    name: 'counsellors-delete',
    props: {
        counsellor: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        deleteCounsellor() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?deleteCounsellorsData&id=${this.counsellor.id}`;

            // Set loading
            this.loading = true;

            // POST request
            fetch(api).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Update system settings
                if (json.result.match(/OK/i)) {
                    // Success
                    that.$emit('setAlert', `${that.counsellor.givenName} ${that.counsellor.surname} has been successfully been deleted.`, true, 'success');
                } else if (json.result.match(/WARNING/i)) {
                    // Other error
                    that.$emit('setAlert', `${that.counsellor.givenName} ${that.counsellor.surname} could not be deleted. ${json.message}.`, true, 'warning');
                } else {
                    // Internal error
                    that.$emit('setAlert', `${that.counsellor.givenName} ${that.counsellor.surname} could not be deleted. An error has occurred. Please contact your system administrator.`, true, 'danger');
                }

                that.refreshData();
                that.loading = false;
                $(`#counsellorDelete-${that.counsellor.id}`).modal('hide');
            }).catch(function () {
                // Internal error
                that.$emit('setAlert', `${that.counsellor.givenName} ${that.counsellor.surname} could not be deleted. An error has occurred. Please contact your system administrator.`, true, 'danger');
                that.loading = false;
                $(`#counsellorDelete-${that.counsellor.id}`).modal('hide');
            })
        },
        getDataTarget() {
            return `#counsellorDelete-${this.counsellor.id}`;
        },
        getModalId() {
            return `counsellorDelete-${this.counsellor.id}`;
        },
        refreshData() {
            this.$emit('refreshData');
        }
    }
}
</script>